import * as React from 'react';
import * as elog from '@reverbdotcom/commons/dist/elog';
import IdentifyShopper from './identify_shopper';
import ChallengeShopperModal from './challenge_shopper_modal';
import {
  core_apimessages_AdyenPaymentResult_PaymentStatus as PaymentStatus,
} from '../../schemas/rql';


interface Props {
  challengeToken: string;
  fingerprintToken: string;
  paymentStatus: PaymentStatus;
  onIdentifyShopperComplete(fingerprintResult: string): void;
  onChallengeShopperComplete(challengeResult: string): void;
}

const TAG = 'adyen.threeds2_interaction';

export default function ThreeDS2Interaction(props: Props) {
  /**
   * onError will be called concurrently with the complete function, so the most
   * action we can take is to also log the error, since complete should continue
   * to submit the call to pay
   */
  function onError(e: Error) {
    elog.info(`${TAG}.error`, { error_message: e.message, paymentStatus: props.paymentStatus });
  }

  if (props.paymentStatus === PaymentStatus.IDENTIFY_SHOPPER_REQUIRED) {
    return (
      <IdentifyShopper
        key={props.fingerprintToken}
        fingerprintToken={props.fingerprintToken}
        onComplete={props.onIdentifyShopperComplete}
        onError={onError}
      />
    );
  }

  if (props.paymentStatus === PaymentStatus.CHALLENGE_SHOPPER_REQUIRED) {
    return (
      <ChallengeShopperModal
        key={props.challengeToken}
        challengeToken={props.challengeToken}
        onComplete={props.onChallengeShopperComplete}
        onError={onError}
      />
    );
  }

  return null;
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/credit_cards/threeds2/threeds2_interaction.tsx